import cn from "app/util/classnames";
import IconArrow from "app/icons/IconArrow";

const GAMES_HOME_URL = import.meta.env.VITE_GAMES_HOME_URL as string;

interface ExitGameButtonProps {
  className?: string;
  hideText?: boolean;
  alwaysShowText?: boolean;
  fillColor?: string;
  textColor?: string;
}

export default function ExitGameButton({
  className,
  hideText = false,
  alwaysShowText = false,
  fillColor = undefined,
  textColor = "text-inherit",
}: ExitGameButtonProps) {
  return (
    <a
      href={GAMES_HOME_URL}
      target="_top"
      className={cn("flex items-center gap-0.5", className)}
    >
      <span className="flex h-10 w-10 items-center justify-center">
        <IconArrow fill={fillColor} />
      </span>
      {!hideText && (
        <span
          className={cn(
            "w-fit text-sm font-bold uppercase ",
            !alwaysShowText && "sr-only md:not-sr-only",
            textColor
          )}
        >
          MORE TED GAMES
        </span>
      )}
    </a>
  );
}